import { cssProps } from '@oracle/oraclejet-cssprops';

const styles = {
  base: cssProps`${{
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    backgroundColor: 'rgba(0,0,0,.5)'
  }}`
};

const ModalBackdrop = () => <div class={styles.base} />;

export default ModalBackdrop;
